module.exports = __webpack_public_path__ + "static/img/ic_jiantou.1c0ec113.svg";